import React from 'react';
import { Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { AgentWrapper } from '../styles/commonStyles';

export const Header = () => {
	return (
		<>
			{/* Header */}
			<AgentWrapper
				className="AtAmiga-font"
				sx={(theme: Theme) => ({
					backgroundColor: 'transparent',
					backdropFilter: 'blur(24px) saturate(40%)',
					WebkitBackdropFilter: 'blur(24px) saturate(40%)',
					borderBottom: `1px solid ${theme.palette.divider}`,
					padding: { xs: '16px 0', sm: '18px 0', md: '32px 0' },
					mt: {
						xs: '60px',
						sm: '60px',
						md: '0px',
					},
				})}
			>
				<Typography
					color="textPrimary"
					display={'inline'}
					variant={'h1'}
					sx={{
						fontFamily: 'AtAmiga',
						fontSize: { xs: '20px', sm: '32px', md: '48px' },
						lineHeight: 1.2,
					}}
				>
					AI AGENT{' '}
					<Typography
						component="span"
						color="primary.main"
						display={'inline'}
						sx={{
							fontFamily: 'AtAmiga',
							fontSize: { xs: '20px', sm: '32px', md: '48px' },
						}}
					>
						ATLAS
					</Typography>
				</Typography>
			</AgentWrapper>
		</>
	);
};
